import { render, staticRenderFns } from "./ProductsUpdate.vue?vue&type=template&id=42e2ed1d"
import script from "./ProductsUpdate.vue?vue&type=script&lang=js"
export * from "./ProductsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports